import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { PlusIcon } from "lucide-react";

export function Empty({
  title = "",
  message = "",

  children,
}: any) {
  return (
    <Card className="text-center py-10">
      <CardHeader>
        <CardTitle className="text-2xl">{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-muted-foreground mb-4">{message}</p>

        {children}
      </CardContent>
    </Card>
  );
}
